/* eslint-disable*/
export function formatCurrencyBRL(value: number | string): string {
    return Number(value).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function formatDate(value: Date): string {
    return new Date(value).toLocaleDateString('pt-BR');
}

export function isNegativeNumber(value: number | string): boolean {
    return Number(value) <= 0 ? true : false;
}

export function formatStringToBool(value: string): boolean {
    return value == "true" ? true : false;
}